import UserRegisterSuccess from './UserRegisterSuccess';

export default UserRegisterSuccess;
